import React from "react";
import { ReactComponent as Trash } from "assets/svgs/trash.svg";
import { useGlobalContext } from "context/global";

const ClearCart = ({ removeCount = 0, onClick }) => {
	const { translation } = useGlobalContext();

	if (removeCount < 2) return null;
	
	return (
		<div className="flex sticky -bottom-4.5 bg-clear-cart z-30 justfiy-center py-1">
			<button onClick={onClick} className="cart-action-btn m-auto gap-1 z-30 ">
				<Trash />
				<span className="text-sm">{translation.cart?.clear_cart}</span>
			</button>
		</div>
	);
};

export default ClearCart;